import Grid from '@mui/material/Grid';
import AnalysisDescriptorsTable from 'pages/ScenarioExposure/Flow/ScenariosManagement/AnalysisDescriptorsTable';
import Conditions from 'pages/ScenarioExposure/Flow/ScenariosManagement/ConditionsTable';
import Descriptors from 'pages/ScenarioExposure/Flow/ScenariosManagement/DescriptorsTable';
import AnalysisConditionsTable from 'pages/ScenarioExposure/Flow/ScenariosManagement/ERCAmbiente/AnalysisConditionsTable';
import React, { useState } from 'react';
import { ERC } from 'utils/constants/descriptorTypes';
import { TABLE_HEIGHT_SPLIT_4VIEW } from 'utils/ui/constants';

const TABLE_HEIGHT = TABLE_HEIGHT_SPLIT_4VIEW(0);

const Component = props => {
  const { lcs, scenario, flowScenarioDescriptors, substanceId } = props;

  // TODO Conditions at this level
  const [descriptorId, setDescriptorId] = useState(null);
  const [analysisDescriptorId, setAnalysisDescriptorId] = useState(null);

  return (
    <Grid container>
      <Grid size={7}>
        <Descriptors
          descriptorId={descriptorId}
          setDescriptorId={setDescriptorId}
          descriptorFilter={ERC}
          scenario={scenario}
          substanceId={substanceId}
          lcs={lcs}
          TABLE_HEIGHT={TABLE_HEIGHT}
        />
      </Grid>
      <Grid size={5}>
        <AnalysisDescriptorsTable
          descriptorId={analysisDescriptorId}
          setDescriptorId={setAnalysisDescriptorId}
          descriptorFilter={ERC}
          flowScenarioDescriptors={flowScenarioDescriptors}
          TABLE_HEIGHT={TABLE_HEIGHT}
        />
      </Grid>
      <Grid size={7}>
        <Conditions
          descriptorFilter={ERC}
          descriptorId={descriptorId}
          conditionsFilter={'Ambiente'}
          scenario={scenario}
        />
      </Grid>
      <Grid size={5}>
        <AnalysisConditionsTable
          descriptorId={analysisDescriptorId}
          scenarioDescriptors={flowScenarioDescriptors}
          conditionsFilter={'Ambiente'}
        />
      </Grid>
    </Grid>
  );
};

export default Component;
